import React from "react"
import PropTypes from "prop-types"

import StaticImage from "../../StaticImage"
import Card from "../../layout/card"

import { BodyText, InlineText } from "../../Typography/Typography"
import {
  bookletImage,
  button,
  buttonContainer,
  careGuideDownload,
} from "./styles.module.scss"
import ButtonLink from "../../ButtonLink/ButtonLink"

export default function CareGuideDownload({ location }) {
  return (
    <Card extraClasses={careGuideDownload}>
      <div>
        <BodyText light>Not sure where to start?</BodyText>
        <BodyText marginBottom large bold>
          Read our expert guide to finding the right care home
        </BodyText>
        <div className={buttonContainer}>
          <ButtonLink
            to="https://www.caresourcer.com/guide-to-finding-the-right-care-home/"
            outline
            centeredContent
            className={button}
            clickEvent={{
              name: "SEO Filtered Directory Viewed - Care Guide Button Clicked",
              properties: { "GEO Location": location },
            }}
          >
            <InlineText brand noMarginBottom>
              Get the guide
            </InlineText>
          </ButtonLink>
        </div>
      </div>
      <StaticImage name="care_guide_booklet" className={bookletImage} />
    </Card>
  )
}

CareGuideDownload.propTypes = {
  location: PropTypes.string.isRequired,
}
